import Bar from '../Bar/Bar'
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';


const Experty = ({image , text , name, BarValue , svg = false}) => {
   const {t} =  useTranslation();
  
  return (
    
      <div className="w-full p-4 md:w-1/2 lg:w-1/3 boxer experties ">
      <div className="flex flex-col   hover:shadow-2xl hover:shadow-white hover:scale-105 hover:-translate-y-4 shadow-inner-white  border-[#0000ff] rounded-3xl border-4">
       <div className=' text-center'><Bar number={BarValue}/></div>
        <div className="py-7 bg-transparent opacity-90 text-white rounded-t ">
        <div className='flex justify-center'> 
            
             { 
             svg ? svg :
              <img className={` ${text == t("Chakra") || text == t("Gsap") || text == t("Mongo") ? "rounded-full" : ""} App-logo h-40 bg-transparent `} src={image}  alt="" />
             }
        </div>

        </div>
        <div>
          <div className="pt-1 pb-5 bg-transparent   text-white rounded-b">
          <h1 className='text-white text-xl pb-5 font-bold font-serif'>{text}</h1>
          <Button Data={name}/>
          </div>
        </div>
      </div>
    </div>
  
  
  )
}

export default Experty
